import { useSelector } from 'react-redux';
import type { RootState } from 'app/store';

import config from '@/config.json';

export default function useSelectedPharmacyTimezone(): string {
  const { selectedPharmacy } = useSelector((state: RootState) => state.pharmacySelector);

  return selectedPharmacy?.timezone || config.defaultTimezone;
}
